import React from 'react'
import Form from 'react-bootstrap/Form'

const SwitchToggle = ({ checked, onChange, classNameParent, textCheck, textUnChecked, ...props }) => {
  const handleChangeChecked = e => {
    onChange(e)
  }

  return <div className={classNameParent}>
    <Form.Check
      {...props}
      checked={checked}
      type="switch"
      label={checked ? textCheck : textUnChecked}
      onChange={handleChangeChecked}
      value={checked ? 1 : 0}
    />
  </div>
}
SwitchToggle.defaultProps = {
  disabled: false,
  classNameParent: 'col-12',
  onChange: () => {},
  required: false,
  textCheck: 'Activo',
  textUnChecked: 'Inactivo'
}

export default SwitchToggle